// eslint-disable-next-line @nx/enforce-module-boundaries
import { definePreset } from '@primeuix/themes';
// eslint-disable-next-line @nx/enforce-module-boundaries
import Aura from '@primeuix/themes/aura';

import { messageOverride } from './components/message.override';
import { paginatorOverride } from './components/paginatorOverride';
import { popoverOverride } from './components/popover.override';
import {
  accordionOverride,
  autocompleteOverride,
  breadcrumsOverride,
  buttonOverride,
  cardOverride,
  checkboxOverride,
  datePickerOverride,
  dialogOverride,
  fileUploadOverride,
  gridOverride,
  inputTextOverride,
  listBoxOverride,
  menuOverride,
  multiselectOverride,
  progressbarOverride,
  selectDropdownOverride,
  tabOverride,
  tagOverride,
  toastOverride,
  toggleButtonOverride,
  treeSelectOverride,
  treeTableOverride,
} from './components';

const dnvThemePreset = definePreset(Aura, {
  primitive: {
    green: {
      50: '#e8f5e7',
      100: '#c5e6c3',
      200: '#9fd69c',
      300: '#78c674',
      400: '#5ab956',
      500: '#3f9c35',
      600: '#388e2f',
      700: '#307d27',
      800: '#286d1f',
      900: '#1b5010',
      950: '#0d2808',
    },
  },
  semantic: {
    primary: {
      50: '#F2F5FA',
      100: '#C2CFE5',
      200: '#91A8D0',
      300: '#6182BB',
      400: '#305BA6',
      500: '#003591',
      600: '#002D7B',
      700: '#002566',
      800: '#001D50',
      900: '#00153A',
      950: '#000D24',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8f9fa',
          100: '#e6e6e5',
          200: '#dee2e6',
          300: '#cbcac8',
          400: '#bdbdbd',
          500: '#9e9e9e',
          600: '#757575',
          700: '#616161',
          800: '#424242',
          900: '#212121',
          950: '#1a1a1a',
        },
        highlight: {
          background: 'rgba(33, 150, 243, 0.06)',
          focusBackground: 'rgba(33, 150, 243, 0.24)',
          color: '{surface.900}',
          focusColor: '{surface.900}',
        },
        formField: {
          borderColor: '#cbcac8',
          hoverBorderColor: '#bdbdbd',
          focusBorderColor: '#2196f3',
        },
        content: {
          background: '{surface.0}',
          hoverBackground: '{surface.100}',
          borderColor: '{surface.200}',
          selectedBackground: '{highlight.background}',
          color: '{text.color}',
          hoverColor: '{text.hover.color}',
        },
        list: {
          option: {
            focusBackground: '{surface.100}',
            selectedBackground: '{highlight.background}',
            selectedFocusBackground: '{highlight.focus.background}',
            color: '{text.color}',
            focusColor: '{text.hover.color}',
            selectedColor: '{highlight.color}',
            selectedFocusColor: '{highlight.focus.color}',
          },
        },
      },
    },
  },
  components: {
    button: buttonOverride,
    multiselect: multiselectOverride,
    checkbox: checkboxOverride,
    listbox: listBoxOverride,
    progressbar: progressbarOverride,
    inputtext: inputTextOverride,
    datatable: gridOverride,
    togglebutton: toggleButtonOverride,
    popover: popoverOverride,
    breadcrumb: breadcrumsOverride,
    select: selectDropdownOverride,
    tabs: tabOverride,
    tag: tagOverride,
    paginator: paginatorOverride,
    menu: menuOverride,
    dialog: dialogOverride,
    treeselect: treeSelectOverride,
    datepicker: datePickerOverride,
    accordion: accordionOverride,
    treetable: treeTableOverride,
    card: cardOverride,
    fileupload: fileUploadOverride,
    message: messageOverride,
    autocomplete: autocompleteOverride,
    toast: toastOverride,
  },
});

export default dnvThemePreset;
